module.exports = __webpack_public_path__ + "img/fixed_img.932648de.svg";